"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AutoDataProvider_1 = __importDefault(require("../AutoDataProvider"));
var AcuraProvider = /** @class */ (function (_super) {
    __extends(AcuraProvider, _super);
    function AcuraProvider(name, config) {
        var _this = _super.call(this, name) || this;
        _this.config = config;
        _this.gtmId = "GTM-NW8MXLT";
        _this.patchWindowWithDealerCode(config);
        _this.patchWindowWithHondaConfig();
        _this.loadGTMScript(_this.gtmId);
        if (config.load_orbee) {
            _this.loadOrbeeScript(config.iframe);
        }
        return _this;
    }
    AcuraProvider.prototype.loadOrbeeScript = function (iframe) {
        // tslint:disable-next-line:only-arrow-functions
        (function (w, d, n, o, g) {
            // @ts-ignore
            w.orbObject = w.orbObject || n;
            if (!w[n]) {
                w[n] = function () {
                    return (w[n].q = w[n].q || []).push(arguments);
                };
                w[n].q = w[n].q || [];
            }
            var namespace = window.location.hostname.split(".").reverse().splice(0, 2).reverse().join(".");
            var s = d.createElement("script");
            var m = d.getElementsByTagName("script")[0];
            // @ts-ignore
            s.async = 1;
            s.src = g + "%3A" + namespace;
            m.parentNode && m.parentNode.insertBefore(s, m);
        })(iframe.window, iframe.document, "orb", "script", "//scripts.orb.ee/tms.js?sid=2KV4wi9L");
    };
    return AcuraProvider;
}(AutoDataProvider_1.default));
exports.default = AcuraProvider;
